import * as React from 'react';
import { cn } from '#/lib/utils';
import InputMask from '@mona-health/react-input-mask';

type InputProps = React.ComponentProps<'input'> & {
  prependIcon?: React.ReactNode;
  appendIcon?: React.ReactNode;
  iconInside?: boolean; // se true, ícones ficam dentro do input
  mask?: string | (string | RegExp)[]; // máscara do input
  alwaysShowMask?: boolean; // se true, mostra a máscara mesmo quando vazio
};

function Input({
  className,
  type,
  prependIcon,
  appendIcon,
  iconInside = true,
  mask = '',
  alwaysShowMask = false,
  ...props
}: InputProps) {
  const inputClass = cn(
    'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-10 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
    'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
    'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
    iconInside && (prependIcon || appendIcon) ? 'pl-9 pr-9' : '',
    className
  );

  // InputMask doesn't support type="color", use native input for special types
  const useNativeInput =
    type === 'color' ||
    type === 'file' ||
    type === 'range' ||
    type === 'date' ||
    type === 'datetime-local' ||
    type === 'time' ||
    type === 'week' ||
    type === 'month';

  return (
    <div className="relative flex w-full items-center">
      {prependIcon && iconInside && (
        <span className="text-muted-foreground pointer-events-none absolute left-2 flex items-center">
          {prependIcon}
        </span>
      )}

      {!iconInside && prependIcon && (
        <span className="text-muted-foreground mr-2 flex items-center">{prependIcon}</span>
      )}

      {useNativeInput ? (
        <input className={inputClass} type={type} {...props} />
      ) : (
        <InputMask mask={mask} alwaysShowMask={alwaysShowMask} className={inputClass} type={type} {...props} />
      )}

      {appendIcon && iconInside && (
        <span className="text-muted-foreground pointer-events-none absolute right-2 flex items-center">
          {appendIcon}
        </span>
      )}

      {!iconInside && appendIcon && <span className="text-muted-foreground ml-2 flex items-center">{appendIcon}</span>}
    </div>
  );
}

export { Input };
